module.exports = __webpack_public_path__ + "img/cur-banner.af31a410.png";